import { render, staticRenderFns } from "./LinkApi.vue?vue&type=template&id=42f2ab18&scoped=true"
import script from "./LinkApi.vue?vue&type=script&lang=js"
export * from "./LinkApi.vue?vue&type=script&lang=js"
import style0 from "./LinkApi.vue?vue&type=style&index=0&id=42f2ab18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f2ab18",
  null
  
)

export default component.exports